import React from 'react'
import styled from 'styled-components'

const Center = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
background-color: var(--gray-0);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const Item = styled.div`
    width: 90px;
    text-align: center;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    color: #bac0cb;
    line-height: 16px;

    i {
        font-size: 28px;
        padding: 10px;
    }
`

export default function NoSpreadSheet() {
    return (
        <Center>
            <Item>
                <i className="far fa-file-spreadsheet" />{' '}
            </Item>
            <Item> No spreadsheet selected </Item>
        </Center>
    )
}
